import React, { PureComponent } from "react";
import { connect } from "react-redux";

import BubbleComponent from "./BubbleComponent";
import PropTypes from "prop-types";
import { TTP_HOME_URL, BUBBLE_EVENTS } from "Config";

import {
  displaySidebarAlbums,
  setSelectedUsers,
  openSidebar,
  setOpenDeleteConfirm,
  setAddMediaModalOpened
} from "Actions";

import { archiveMedias, maskMedias } from "Thunks";
import { toast } from "react-toastify";

import _ from "i18n";

class BubbleContainer extends PureComponent {
  static propTypes = {
    bubble: PropTypes.object.isRequired,
    displaySidebarAlbums: PropTypes.func
  };

  handleClickBubble = e => {
    const {
      bubble,
      openSidebar,
      setOpenDeleteConfirm,
      setAddMediaModalOpened
    } = this.props;
    if (bubble.disabled) return false;
    switch (bubble.event) {
      case BUBBLE_EVENTS.ADD_TO_ALBUM:
        this.handleAddToAlbum();
        break;
      case BUBBLE_EVENTS.DELETE_SELECTED_MEDIAS:
        this.handleDeleteSelectedMedias();
        break;
      case BUBBLE_EVENTS.SELECT_ALL_USERS:
        this.handleSelectAllUsers();
        break;
      case BUBBLE_EVENTS.DESELECT_ALL_USERS:
        this.handleDeselectAll();
        break;
      case BUBBLE_EVENTS.ADD_NEW_USER:
        this.addNewUserLink();
        break;
      case BUBBLE_EVENTS.HANDLE_CLICK_SETTING:
        openSidebar();
        break;
      case BUBBLE_EVENTS.ADD_NEW_MEDIA:
        setAddMediaModalOpened(true);
        break;
      case BUBBLE_EVENTS.DELETE_MEDIAS:
        setOpenDeleteConfirm(true);
        break;
      case BUBBLE_EVENTS.MASK_MEDIAS:
        this.handleMaskMedias(e);
        break;
      case BUBBLE_EVENTS.ARCHIVE_MEDIAS:
        this.handleArchiveMedias();
        break;
      default:
        this.emptyFunction();
    }
  };

  emptyFunction = () => false;

  addNewUserLink() {
    const returnto = encodeURIComponent(window.location.href);
    const addUserLink = `${TTP_HOME_URL}/users/create`;
    window.open(`${addUserLink}?returnto=${returnto}`, "_self");
  }

  handleSelectAllUsers() {
    const { users, setSelectedUsers } = this.props;
    const ids = users.map(u => u.id);
    setSelectedUsers(ids);
  }

  handleDeselectAll() {
    const { setSelectedUsers } = this.props;
    setSelectedUsers([]);
  }

  handleAddToAlbum(e) {
    const { displaySidebarAlbums } = this.props;
    displaySidebarAlbums(true);
    setTimeout(arg => {
      document
        .getElementsByClassName("sidebarContent")
        .item(0)
        .classList.add("active");
    }, 10);
  }

  handleArchiveMedias() {
    const { checks, archiveMedias } = this.props;
    const ids = checks.map(m => m.id);
    archiveMedias(ids)
      .then(resp => {
        toast.success(
          <div className="flashMessage">
            <div className="flahMessage__icon">
              <i className="icotam-check-outline" />
            </div>
            <div className="flashMessage__body">
              <h5>{_("Success")}</h5>
              <p>{_("Medias archived successfully")}</p>
            </div>
          </div>
        );
      })
      .catch(e => {
        toast.error(
          <div class="flashMessage">
            <div class="flahMessage__icon">
              <i className="icotam-close-outline" />
            </div>
            <div className="flashMessage__body">
              <h5>{_("Error")}</h5>
              <p>{_("Error when updating medias")}</p>
            </div>
          </div>
        );
      });
  }

  handleMaskMedias(e) {
    const { checks, maskMedias } = this.props;
    const ids = checks.map(m => m.id);
    maskMedias(ids)
      .then(resp => {
        toast.success(
          <div className="flashMessage">
            <div className="flahMessage__icon">
              <i className="icotam-check-outline" />
            </div>
            <div className="flashMessage__body">
              <h5>{_("Success")}</h5>
              <p>{_("Medias masked successfully")}</p>
            </div>
          </div>
        );
      })
      .catch(e => {
        toast.error(
          <div class="flashMessage">
            <div class="flahMessage__icon">
              <i className="icotam-close-outline" />
            </div>
            <div className="flashMessage__body">
              <h5>{_("Error")}</h5>
              <p>{_("Error when updating medias")}</p>
            </div>
          </div>
        );
      });
  }

  render() {
    const { bubble, masking, archiving } = this.props;

    return (
      <BubbleComponent
        bubble={bubble}
        onClickBubble={e => {
          this.handleClickBubble(e);
        }}
        masking={masking}
        archiving={archiving}
      />
    );
  }
}

const mapStateToProps = state => ({
  users: state.users.items,
  usersFetched: state.users.fetched,
  selectedUsers: state.settings.selectedUsers,
  navCommunity: state.auth.navCommunity,
  checks: state.medias.listing.checks,
  masking: state.medias.listing.masking,
  archiving: state.medias.listing.archiving
});

const mapDispatchToProps = dispatch => ({
  displaySidebarAlbums: visible => dispatch(displaySidebarAlbums(visible)),
  setSelectedUsers: ids => dispatch(setSelectedUsers(ids)),
  openSidebar: () => dispatch(openSidebar()),
  setOpenDeleteConfirm: visible => dispatch(setOpenDeleteConfirm(visible)),
  setAddMediaModalOpened: visible => dispatch(setAddMediaModalOpened(visible)),
  maskMedias: ids => dispatch(maskMedias(ids)),
  archiveMedias: ids => dispatch(archiveMedias(ids))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BubbleContainer);



// WEBPACK FOOTER //
// ./src/components/BubblesList/Bubble/BubbleContainer.js